export const CROSS_JOIN_NUDGE_PROJECT_GATE = 'cross-join-nudge-in-project-pages-gate';
export const CROSS_JOIN_NUDGE_PROJECT_EXPERIMENT = 'cross-join-nudge-in-project-pages';
